import addAgencyIdAndExecuteFinishToRender from 'utils/addAgencyIdAndExecuteFinishToRender'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import { numberToCurrency } from '@hc-frontend/utils'
import getValueFees from 'core/controllerPlans/getValueFees'
import moneyFormat from 'utils/format/money'
import toggleClass from 'utils/DOM/toggleClass'
import { BTM, BTM_KEY } from 'core/constants/products'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import { sendQuotesViewEvent } from 'core/services/email/blueshift/implementations/quotes'
import { updateSessionContext } from 'core/services/updateApplicantContext'
import config from './config'
import { preventOnCloseEvent } from 'core/services/onClose'
import clickEventName from 'utils/DOM/clickEventName'

const asMoneyWithoutDecimal = numberToCurrency

function hideLoading() {
  toggleClass(document.body, 'show-loading', false)
}

export function renderPlans(state, wrapId = '#js-wrap', templateId = 'template-plan') {
  const template = Templater(getById(templateId).innerText)

  if (!state.plansByType[BTM]) {
    return
  }

  innerHTML(
    wrapId,
    state.plansByType[BTM].map((id, index) => {
      const plan = state.plans[id]
      const monthly = plan.duration.monthly

      return template({
        index,
        logo: state.carriers[plan.carrierId].logo,
        carrier: state.carriers[plan.carrierId],
        planId: plan.planId,
        period: 364,
        planName: plan.planName,
        premium: moneyFormat(monthly.premium),
        applicationFee: moneyFormat(getValueFees('Application Fee', monthly.fees)),
        brochure: state.brochures[plan.brochureId],
        deductible: asMoneyWithoutDecimal(+plan.coreBenefits.deductible),
        coinsurance: plan.coreBenefits.userCoinsurance,
        moop: asMoneyWithoutDecimal(+plan.coreBenefits.outOfPocketMax),
        coverage: asMoneyWithoutDecimal(+plan.coreBenefits.lifetimeMax),
        networkProvider: plan.coreBenefits.networkProvider,
        productName: BTM_KEY
      })
    }).join('')
  )
}

function initDOM(state) {
  $('body')
    .on(clickEventName, '.plan__button', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.plan__details', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.ProgressBar__link', function () {
      preventOnCloseEvent()
    })

  if (state.hcStorage.location.state_acronym === 'NE') {
    toggleClass(document.body, 'ne')
  }

  updateSessionContext(state.hcStorage, config)

  if (!state.plansByType[BTM] || state.plansByType[BTM].length === 0) {
    toggleClass(document.body, 'noPlans')
    return import('pug/mixins/noCoverage/coverageAlternatives')
      .then(method => method.default('btm'))
      .then(hideLoading)
  }

  sendQuotesViewEvent()
  renderPlans(state)
  toggleClass(document.body, 'clic', true)
  hideLoading()

  addAgencyIdAndExecuteFinishToRender()
}

export default initDOM
